export const Salary = {
  en: {
    Salary: 'Salary',
    'Reset the prototype data': 'Reset the prototype data',
    'Reset the prototype data confirmation':
      'All locally stored prototype data — accruals, payouts and the cancellation reasons — will be deleted and seeded anew. The page will reload.',
    Reset: 'Reset',
    'The period does not include today — the operations are read-only':
      'The period does not include today — the operations are read-only',

    Week: 'Week',
    Month: 'Month',
    Year: 'Year',
    'Custom period': 'Custom period',
    From: 'From',
    Till: 'Till',
    now: 'now',

    'Salary payout': 'Salary payout',
    'Profit payout': 'Profit payout',
    Bonus: 'Bonus',
    Deductions: 'Deductions',

    'Employee name': 'Name',
    'Opening balance': 'Opening balance',
    'Paid for the previous period': 'Paid for the previous period',
    Accrued: 'Accrued',
    'Paid for the current period': 'Paid for the current period',
    'Closing balance': 'Closing balance',
    'The amount accrued but not paid out over the previous periods':
      'The amount accrued but not paid out over the previous periods (month, year and so on). It is what the venue owes the employee at the start of the selected period; a negative value means the employee owed the venue.',
    'The amount paid in this period against the opening balance':
      'The amount paid in the current period that settles the «Opening balance» column — for example, last month’s salary paid in the first days of this month.',
    'The amount accrued to the employee for the current period — deductions and shortages with a minus':
      'The amount accrued to the employee for the current period. Deductions and stock-count shortages enter with a minus.',
    'The amount paid to the employee for the current period':
      'The amount paid to the employee for the current period. It does not include the «Paid for the previous period» column; together the two show everything the employee received during the period.',
    'The salary left to pay at the end of the period':
      'The salary left to pay at the end of the period. It is what the venue owes the employee at the end of the selected period; a negative value means the employee owes the venue.',

    Executives: 'Executives',
    Managers: 'Managers',
    Administrators: 'Administrators',
    Instructors: 'Instructors',
    'Personal trainers': 'Personal trainers',
    Methodists: 'Methodists',
    SPA: 'SPA',

    'Operation history': 'Operation history',
    All: 'All',
    Details: 'Details',
    'Cancel the operation': 'Cancel the operation',
    'No operations in the period': 'No operations in the period',
    'Paid out': 'Paid out',
    'For the amount': 'For the amount',
    'History total hint: accrued':
      'The sum of every accrual in the list for the selected period. Payouts are not counted, deductions are counted with a minus, cancelled records are not counted.',
    'History total hint: paid':
      'The sum of the payouts made to the employee in the selected period. It can exceed the accrued amount when a payout in this period settles a debt of a previous one.',
    'History total hint: price':
      'The total of the «Ціна» column — what the clients paid for the services and sales the employee earned a share of. Accruals with no price (a rate, hourly salary) are not included.',

    'Monthly or daily rate': 'Rates per month or day',
    'Salary per day': 'Salary per day',
    'Hourly salary': 'Hourly salary',
    'Salary for services': 'Salary for services',
    'Bonus for a sale': 'Bonus for a sale',
    'Paid from salary': 'Paid from salary',
    'Settled from the employee account, sale {{number}}':
      'Settled from the employee account, sale №{{number}}',

    Print: 'Print',
    'This accrual has no breakdown': 'This accrual has no breakdown',
    'Rate for one month': 'Rate for one month',
    'Accrued for {{count}} working days': 'Accrued for {{count}} working days',
    'Rate for one shift': 'Rate for one shift',
    'Accrued for a shift ({{from}} − {{till}})':
      'Accrued for a shift ({{from}} − {{till}})',
    'Salary for one hour': 'Salary for one hour',
    'Hours worked ({{from}} − {{till}})': 'Hours worked ({{from}} − {{till}})',
    'Accrued for {{hours}} hours': 'Accrued for {{hours}} hours',
    'hours short': 'h',
    'Service price': 'Service price',
    '{{percent}}% of the service price': '{{percent}}% of the service price',
    'Accrued from a service priced at {{price}}':
      'Accrued from a service priced at {{price}}',
    'Sale price': 'Sale price',
    '{{percent}}% of the sale': '{{percent}}% of the sale',
    'Accrued from a sale of {{price}}': 'Accrued from a sale of {{price}}',

    'Cancellation reason': 'Cancellation reason',
    'Cancellation reasons': 'Cancellation reasons',
    Reason: 'Reason',
    Add: 'Add',
    'Wrong amount': 'Wrong amount',
    'Wrong employee': 'Wrong employee',
    'Paid by mistake': 'Paid by mistake',

    'Payout amount': 'Payout amount',
    'The amount exceeds the balance — this is an advance':
      'The amount exceeds the balance — this is an advance',
    'Not enough money on the cash register':
      'Not enough money on the cash register',
    Balance: 'Balance',
    'From the cash register': 'From the cash register',
    'On the cash register': 'On the cash register',
    Notes: 'Notes',
    'Pay out': 'Pay out',
    Employee: 'Employee',
    'No employees': 'No employees',
    Employees: 'Employees',
    'What the columns mean': 'What the columns mean',
  },
  uk: {
    Salary: 'Зарплата',
    'Reset the prototype data': 'Скинути дані прототипу',
    'Reset the prototype data confirmation':
      'Усі локальні дані прототипу — нарахування, виплати та довідник причин відміни — будуть видалені та створені заново. Сторінка перезавантажиться.',
    Reset: 'Скинути',
    'The period does not include today — the operations are read-only':
      'Обраний період не включає сьогодні — операції доступні лише для перегляду',

    Week: 'Тиждень',
    Month: 'Місяць',
    Year: 'Рік',
    'Custom period': 'Інший період',
    From: 'З',
    Till: 'По',
    now: 'зараз',

    'Salary payout': 'Виплата зарплати',
    'Profit payout': 'Виплата прибутку',
    Bonus: 'Премія',
    Deductions: 'Відрахування',

    'Employee name': "Ім'я",
    'Opening balance': 'Початковий залишок',
    'Paid for the previous period': 'Виплачено за попередній період',
    Accrued: 'Нараховано',
    'Paid for the current period': 'Виплачено за поточний період',
    'Closing balance': 'Кінцевий залишок',
    'The amount accrued but not paid out over the previous periods':
      'Сума, яка була нарахованою, але не виплаченою за минулий період (місяць, рік і т.д.). Показує заборгованість закладу перед співробітником на початок обраного періоду. Якщо значення від’ємне — на початок періоду співробітник був винен гроші закладу.',
    'The amount paid in this period against the opening balance':
      'Сума, яка була виплачена в поточному періоді та погашає суму в колонці «Початковий залишок». Наприклад, зарплата за минулий місяць, виплачена в перших числах поточного місяця.',
    'The amount accrued to the employee for the current period — deductions and shortages with a minus':
      'Сума, нарахована співробітнику за поточний період. Відрахування та нестачі входять зі знаком мінус.',
    'The amount paid to the employee for the current period':
      'Сума, виплачена працівникові за поточний період. Не включає в себе суму в колонці «Виплачено за попередній період». Ці дві колонки разом показують суму, яку працівник отримав впродовж періоду.',
    'The salary left to pay at the end of the period':
      'Сума заробітної плати співробітника, яка залишилася до виплати на кінець періоду. Показує заборгованість закладу перед співробітником на кінець обраного періоду. Якщо значення від’ємне — на кінець періоду співробітник винен гроші закладу.',

    Executives: 'Керівники',
    Managers: 'Менеджери',
    Administrators: 'Адміністратори',
    Instructors: 'Інструктори',
    'Personal trainers': 'Персональні тренери',
    Methodists: 'Методисти',
    SPA: 'SPA',

    'Operation history': 'Історія операцій',
    All: 'Все',
    Details: 'Детальніше',
    'Cancel the operation': 'Скасувати',
    'No operations in the period': 'За обраний період операцій немає',
    'Paid out': 'Виплачено',
    'For the amount': 'На суму',
    'History total hint: accrued':
      'Сума всіх нарахувань зі списку за обраний період. Виплати не враховуються, відрахування — з мінусом, скасовані операції не враховуються.',
    'History total hint: paid':
      'Сума виплат співробітнику в обраному періоді. Може перевищувати нараховане, якщо виплата в цьому періоді погашає заборгованість за минулий.',
    'History total hint: price':
      'Сума колонки «Ціна» — скільки заплатили клієнти за послуги та продажі, з яких співробітнику нараховано частку. Нарахування без ціни (ставка, погодинна зарплата) сюди не входять.',

    'Monthly or daily rate': 'Ставки за місяць чи день',
    'Salary per day': 'Зарплата за день',
    'Hourly salary': 'Погодинна зарплата',
    'Salary for services': 'Зарплата за послуги',
    'Bonus for a sale': 'Премія за продаж',
    'Paid from salary': 'Оплачено з зарплати',
    'Settled from the employee account, sale {{number}}':
      'Оплачено з рахунку працівника, продаж №{{number}}',

    Print: 'Друкувати',
    'This accrual has no breakdown': 'Для цього нарахування немає розшифровки',
    'Rate for one month': 'Ставка за один місяць',
    'Accrued for {{count}} working days':
      'Нараховано за {{count}} робочих днів',
    'Rate for one shift': 'Ставка за одну зміну',
    'Accrued for a shift ({{from}} − {{till}})':
      'Нараховано за зміну ({{from}} − {{till}})',
    'Salary for one hour': 'Зарплата за одну годину',
    'Hours worked ({{from}} − {{till}})':
      'Відпрацьовано годин ({{from}} − {{till}})',
    'Accrued for {{hours}} hours': 'Нараховано за {{hours}} годин',
    'hours short': 'год',
    'Service price': 'Ціна послуги',
    '{{percent}}% of the service price': '{{percent}}% від ціни послуги',
    'Accrued from a service priced at {{price}}':
      'Нараховано з послуги вартістю {{price}}',
    'Sale price': 'Ціна продажу',
    '{{percent}}% of the sale': '{{percent}}% від продажу',
    'Accrued from a sale of {{price}}': 'Нараховано з продажу на {{price}}',

    'Cancellation reason': 'Причина відміни',
    'Cancellation reasons': 'Причини відміни',
    Reason: 'Причина',
    Add: 'Додати',
    'Wrong amount': 'Невірна сума',
    'Wrong employee': 'Не той співробітник',
    'Paid by mistake': 'Виплачено помилково',

    'Payout amount': 'Сума оплати',
    'The amount exceeds the balance — this is an advance':
      'Сума перевищує залишок — це аванс',
    'Not enough money on the cash register': 'На касі недостатньо коштів',
    Balance: 'Залишок',
    'From the cash register': 'З каси',
    'On the cash register': 'На касі',
    Notes: 'Примітки',
    'Pay out': 'Виплатити',
    Employee: 'Працівник',
    'No employees': 'Співробітників немає',
    Employees: 'Співробітники',
    'What the columns mean': 'Що означають колонки',
  },
};
